/**
 * Applies classes based on the filters lenght and the child count, to keep everything aligned to the grid
 * @param {number} columnCount The number of columns of the grid
 * @param {number} childCount The number of children to sit in the grid - useful if there is a row with spaces
 * @param {boolean} desktopOnly Whether to specify that grid view is for desktop widths only
 * */
export const prepareGlobalFilterClasses = (columnCount, childCount, desktopOnly = false) => {
    return ` global-filters columncount-${columnCount} childcount-${childCount} ${desktopOnly && 'desktop-only'}`;
};
